import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=6e263a8e&scoped=true&"
import script from "./Draggable.js?vue&type=script&lang=js&"
export * from "./Draggable.js?vue&type=script&lang=js&"
import style0 from "./Draggable.scss?vue&type=style&index=0&id=6e263a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e263a8e",
  null
  
)

export default component.exports